<span>{{ fieldValue | formatLongText: 50 }}</span>
